module.exports = __webpack_public_path__ + "static/media/app icon (3).d65128de.png";